export default "__VITE_ASSET__D4Pgxyx9__"